// @flow

import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  px, pb, my, pt
} from 'styled-components-spacing';

export const StyledWrapper = styled.div`
  ${px(3.5)}
  ${pt(1)}
  ${pb(3.5)}
  margin-top: 8.5rem !important;
  ${breakpoint('desktop')`
    ${pt(4)}
    ${px(4)}
    ${pb(4)}
    ${my(-3)}
  `}
`;

export const ButtonBar = styled.div`
  display: flex;
  width: 100%;
`;
